import { Box, BoxProps } from '@mui/material'

interface ICollapseTitle extends BoxProps {
  children: React.ReactNode
}

export const CollapseTitle = (params: ICollapseTitle) => {
  const { children, ...props } = params
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '12px'
      }}
      {...props}>
      {children}
    </Box>
  )
}
